// -----------------------------------------------------------------
// JavaScript for the Mini Basket Grid Editor
// -----------------------------------------------------------------

TECL_MiniBasket = {

    // Initialise the mini basket
    Initialise: function() {

        if ($(".miniBasket").length > 0) {

            $("body").off(".miniBasket");

            // Remove item event
            $("body").on("click.miniBasket", ".miniBasket-remove", function() {
                var itemId = $(this).closest("tr").attr("data-mbItemId");
                TECL_MiniBasket.RemoveItem(itemId);
            });

            // Update item event
            $("body").on("click.miniBasket", ".miniBasket-update", function() {
                var item = $(this).closest("tr");
                var itemId = item.attr("data-mbItemId");
                var quantity = item.find("[name='miniBasket-quantity']").val();
                TECL_MiniBasket.UpdateItem(itemId, quantity);
            });

            TECL_MiniBasket.Update();
        }
    },

    // Update the mini basket
    Update: function() {

        if (TECL_Master.AddLock("updateMiniBasket")) {

            // Update the basket
            $.ajax({
                url: "/umbraco/Surface/MiniBasketSurface/Update",
                type: "POST",
                error: function() {
                    TECL_Master.ClearLock("updateMiniBasket");
                },
                success: function(result) {
                    TECL_Master.ClearLock("updateMiniBasket");
                    TECL_MiniBasket.RefreshData(result);
                }
            });
        }
    },

    // Remove an item from the basket
    RemoveItem: function(itemId) {

        if (TECL_Master.AddLock("removeMiniBasketProduct")) {

            // Update the basket
            $.ajax({
                url: "/umbraco/Surface/MiniBasketSurface/RemoveItem",
                data: {
                    itemId: itemId
                },
                type: "POST",
                error: function() {
                    TECL_Master.ClearLock("removeMiniBasketProduct");
                },
                success: function(result) {
                    TECL_Master.ClearLock("removeMiniBasketProduct");
                    TECL_MiniBasket.RefreshData(result, true);
                }
            });
        }
    },

    // Update an item from the basket
    UpdateItem: function(itemId, quantity) {

        if (TECL_Master.AddLock("updateMiniBasketItem")) {

            // Update the basket
            $.ajax({
                url: "/umbraco/Surface/MiniBasketSurface/UpdateItem",
                data: {
                    itemId: itemId,
                    quantity: quantity
                },
                type: "POST",
                error: function() {
                    TECL_Master.ClearLock("updateMiniBasketItem");
                },
                success: function(result) {
                    TECL_Master.ClearLock("updateMiniBasketItem");
                    TECL_MiniBasket.RefreshData(result, true);
                }
            });
        }
    },

    // Rebuild the mini basket using the data provided
    RefreshData: function(basketData, fireEvent) {

        TECL_MiniBasket.Clear();

        if (basketData) {

            try {

                if (basketData.HasItems) {
                    // Update totals
                    $("[data-mbTotalExVat]").html(basketData.TotalExVat);
                    $("[data-mbTotalIncVat]").html(basketData.TotalIncVat);
                    $("[data-mbTotalVat]").html(basketData.TotalVat);

                    // Add product items
                    basketData.BasketItems.forEach(TECL_MiniBasket.AddBasketItem);

                    $(".miniBasket-products").removeClass("hidden");
                    $(".miniBasket-empty").addClass("hidden");
                    $(".miniBasket").find(".btn-checkout").removeClass("hidden");

                    // Trigger an event attached to the body to say that the mini basket has been updated
                    if (fireEvent) {
                        $("body").trigger("update.mb");
                    }
                } else {
                    $(".miniBasket").find(".btn-checkout").addClass("hidden");
                    $(".miniBasket-products").addClass("hidden");
                    $(".miniBasket-empty").removeClass("hidden");
                }

            } catch (e) {

            }
        }

    },

    // Add a basket order line
    AddBasketItem: function(item) {

        var newBasketLine = $("[data-mbItemTemplate]:first").clone();

        newBasketLine.find("[data-mbProductName]").html(item.Name);
        newBasketLine.find("[data-mbProductValue]").html(item.TotalExVat);
        newBasketLine.find("[name='miniBasket-quantity']").val(item.Quantity);
        newBasketLine.attr("data-mbItemId", item.Id);
        newBasketLine.removeAttr("data-mbItemTemplate");

        $(".miniBasket-products").append(newBasketLine);
    },

    // Clear the mini basket
    Clear: function() {
        $(".miniBasket-products").addClass("hidden");
        $(".miniBasket-empty").removeClass("hidden");
        $("[data-mbItemId]").remove();
        $("[data-mbTotalExVat]").html("");
        $("[data-mbTotalIncVat]").html("");
        $("[data-mbTotalVat]").html("");
    }
};
